<template>
  <div class="footer_wrap">
    <div class="footer">
      <div class="f_con">
        <img src="../../static/img/logo.png" alt="" class="logo">
        <div class="information">
          <a :href="privacyUrl[lang]" target="_blank">{{ $t('language.privacy') }}</a>
          <a :href="termsUrl[lang]" target="_blank">{{ $t('language.service') }}</a>
          <a href="./manageRule.html" target="_blank" v-if="lang === 'zh'">{{ $t('language.manage') }}</a>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import store from "../vuex/store";

export default {
  data() {
    return {
      privacyUrl: {
        en: './static/prolicy.html',
        zh: './policy-zh.html',
        kr: './policy-kr.html'
      },
      termsUrl: {
        en: './terms.html',
        zh: './terms-zh.html',
        kr: './terms-kr.html'
      }
    }
  },
  mounted() {
  },
  computed: {
    lang(){
      return store.state.lang
    }
  },
  watch: {
    lang(oldV, newV) {
      if(oldV !== newV) {
        this.$i18n.locale = oldV
      }
    }
  },
  methods: {

  }
}
</script>
<style scoped>
.footer_wrap {
  width: 100%;
  height: 240px;
  background: url(../../static/img/footer.jpg) no-repeat;
  background-size: 100% 100%
}

.footer {
  width: 1200px;
  margin: 0 auto;
  height: 240px;
  text-align: center;
}

.footer .f_con{
  width: 59%;
  margin: 0 auto;
  overflow:hidden
}

.footer .logo {
  display: block;
  float: left;
  margin-top: 85px;
}

.footer .footer_p {
  font-size: 12px;
  color: #999;
  margin-top: 40px;
  float: left;
}

.f-logo {
  font-size: 28px;
  color: #ff5f31;
  margin-top: 120px;
  margin-right: 10%;
  float: left;
}

.information {
  margin-top: 50px;
  float: left;
  text-align: left;
  color: white;
  font-size: 14px;
  margin-left: 10%;
  margin-top: 114px;
}

.information a {
  color: white;
  text-decoration:none
}
.information a:nth-child(2) {
  margin-left: 30px
}
.information a:nth-child(3) {
  margin-left: 30px
}
.information a:hover {
  color: #fcc916;
  text-decoration: underline
}

.information p {
  margin: 5px
}

.information p a {
  text-decoration: none;
  color: white
}
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue